import { SISTER_SEARCHER_VESSEL_COLUMNS } from "../constants/sister-searcher.constants";
import { SisterSearcherVessel } from "../models/sister-searcher.models";
import { formatSisterSearcherValue } from "../utils/sister-searcher-format.utils";
import { twMerge } from "tailwind-merge";

interface SisterSearcherVesselTableProps {
  rows: SisterSearcherVessel[];
  dataTest: string;
  selected?: boolean;
}

// Renders the common PBIP TableA/TableB vessel facts with one consistent empty-value treatment.
// Selected rows use a fixed reference highlight while sister rows retain the alternating scan pattern.
const SisterSearcherVesselTable = ({ rows, dataTest, selected = false }: SisterSearcherVesselTableProps) => (
  <div className="overflow-auto" data-test={dataTest}>
    <table className="w-full min-w-[1900px] border-separate border-spacing-0 text-[11px]">
      <thead className="sticky top-0 z-10 bg-gray-50 text-left text-[10px] uppercase tracking-wide text-gray-500 dark:bg-gray-900 dark:text-gray-400">
        <tr>
          {SISTER_SEARCHER_VESSEL_COLUMNS.map((column) => (
            <th
              key={column.key}
              className="whitespace-nowrap border-b border-gray-200 px-3 py-3 font-semibold dark:border-gray-700"
            >
              {column.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr
            key={row.imo}
            className={twMerge(
              "text-gray-700 dark:text-gray-200",
              selected
                ? "bg-primary-10 dark:bg-teal-950/40"
                : "odd:bg-white even:bg-gray-50/60 hover:bg-primary-10 dark:odd:bg-gray-800 dark:even:bg-gray-800/70 dark:hover:bg-teal-950/50",
            )}
          >
            {SISTER_SEARCHER_VESSEL_COLUMNS.map((column) => (
              <td
                key={`${row.imo}-${column.key}`}
                className={twMerge(
                  "whitespace-nowrap border-b border-gray-100 px-3 py-2 dark:border-gray-700",
                  column.key === "imo" && "font-mono tabular-nums text-green",
                  column.key === "vesselName" && "font-semibold text-gray-900 dark:text-gray-100",
                  column.key === "design" && "max-w-[150px] whitespace-normal leading-4",
                )}
              >
                {formatSisterSearcherValue(row[column.key])}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default SisterSearcherVesselTable;
